import { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { Link } from 'react-router-dom';
import UserEditModal from '../../components/admin/UserEditModal';

// Servicios
// eslint-disable-next-line no-unused-vars
import matchService from '../../services/matchService';
// eslint-disable-next-line no-unused-vars
import userService from '../../services/userService';
// eslint-disable-next-line no-unused-vars
import categoryService from '../../services/categoryService';
// eslint-disable-next-line no-unused-vars
import fieldService from '../../services/fieldService';
import dashboardService from '../../services/dashboardService';
import jornadaService from '../../services/jornadaService';

const Dashboard = () => {
  const [stats, setStats] = useState({
    users: { total: 0, trend: 'up', trendValue: '0%' },
    matches: { total: 0, trend: 'up', trendValue: '0%' },
    inscripciones: { total: 0, trend: 'up', trendValue: '0%' },
    ingresos: { total: 0, formatted: '€0.00', trend: 'up', trendValue: '0%' },
  });

  const [proximaJornada, setProximaJornada] = useState(null);
  const [recentUsers, setRecentUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para los modales de usuarios
  const [showUserViewModal, setShowUserViewModal] = useState(false);
  const [showUserEditModal, setShowUserEditModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // Función para manejar la visualización de un usuario
  const handleViewUser = (user) => {
    console.log('Ver usuario', user);
    if (!user) {
      console.error('Error: No se proporcionó un usuario para visualizar');
      return;
    }
    setCurrentUser(user);
    setShowUserViewModal(true);
  };

  // Función para manejar la edición de un usuario
  const handleEditUser = (user) => {
    console.log('Editar usuario', user);
    if (!user) {
      console.error('Error: No se proporcionó un usuario para editar');
      return;
    }
    setCurrentUser(user);
    setShowUserEditModal(true);
  };

  // Función para manejar la actualización de un usuario
  const handleUserUpdated = (updatedUser) => {
    console.log('Usuario actualizado:', updatedUser);

    // Actualizar la lista de usuarios recientes
    setRecentUsers(
      recentUsers.map((user) =>
        user._id === updatedUser._id
          ? {
            ...updatedUser,
            registeredAt: user.registeredAt, // Mantener la fecha de registro
          }
          : user,
      ),
    );
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        // Obtener estadísticas reales del dashboard
        try {
          const statsData = await dashboardService.getDashboardStats();
          console.log('Estadísticas del dashboard recibidas:', statsData);

          if (statsData.success && statsData.data) {
            setStats(statsData.data);
          }
        } catch (error) {
          console.error('Error fetching dashboard stats:', error);
          // Si hay un error, mantener los valores por defecto
        }

        // Próxima jornada - Obtener datos reales
        try {
          const jornadaData = await jornadaService.getProximaJornada();
          console.log('Datos de próxima jornada recibidos:', jornadaData);

          if (jornadaData.success && jornadaData.data) {
            setProximaJornada(jornadaData.data);
          } else {
            setProximaJornada(null);
          }
        } catch (error) {
          console.error('Error fetching próxima jornada:', error);
          setProximaJornada(null);
        }

        // Usuarios recientes - Obtener datos reales (últimos 5)
        try {
          const userData = await userService.getUsers({ limit: 5, sort: '-createdAt' });
          console.log('Datos de usuarios recibidos:', userData);

          // Verificar si tenemos un array o un objeto con propiedad users
          const usersArray = Array.isArray(userData) ? userData : userData?.users || [];

          // Procesar los datos para asegurar que tienen el formato correcto
          const processedUsers = usersArray.map((user) => ({
            ...user,
            registeredAt: user.registeredAt ? new Date(user.registeredAt) : new Date(),
          }));

          setRecentUsers(processedUsers);
        } catch (error) {
          console.error('Error fetching users:', error);
          // Si hay un error, usar un array vacío
          setRecentUsers([]);
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setError('Error al cargar los datos del dashboard');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <AdminLayout title="Dashboard" subtitle="Cargando...">
        <div className="loading">Cargando datos del dashboard...</div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout title="Dashboard" subtitle="Error">
        <div className="error">{error}</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Dashboard" subtitle="Panel de control y estadísticas generales">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: 'rgba(25, 118, 210, 0.1)' }}>
            <span className="material-icons" style={{ color: '#1976d2' }}>
              people
            </span>
          </div>
          <div className="stat-info">
            <h3>Usuarios Totales</h3>
            <p className="stat-value">{stats.users.total}</p>
            <p className="stat-change positive">
              {stats.users.trendValue}
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)' }}>
            <span className="material-icons" style={{ color: '#4caf50' }}>
              sports_soccer
            </span>
          </div>
          <div className="stat-info">
            <h3>Partidos Programados</h3>
            <p className="stat-value">{stats.matches.total}</p>
            <p className="stat-change positive">
              {stats.matches.trendValue}
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: 'rgba(255, 152, 0, 0.1)' }}>
            <span className="material-icons" style={{ color: '#ff9800' }}>
              how_to_reg
            </span>
          </div>
          <div className="stat-info">
            <h3>Inscripciones</h3>
            <p className="stat-value">{stats.inscripciones.total}</p>
            <p className="stat-change positive">
              {stats.inscripciones.trendValue}
            </p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: 'rgba(233, 30, 99, 0.1)' }}>
            <span className="material-icons" style={{ color: '#e91e63' }}>
              payments
            </span>
          </div>
          <div className="stat-info">
            <h3>Ingresos</h3>
            <p className="stat-value">{stats.ingresos.formatted}</p>
            <p className="stat-change positive">
              {stats.ingresos.trendValue}
            </p>
          </div>
        </div>
      </div>

      <div className="dashboard-row">
        <div className="dashboard-card upcoming-matches">
          <div className="card-header">
            <h2>Próximas Jornadas</h2>
            <Link to="/admin/tournaments/1/players" className="btn-link">
              Ver Todos
            </Link>
          </div>
          <div className="card-content">
            {proximaJornada ? (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Jornada</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Sede</th>
                    <th>Ubicación</th>
                    <th>Inscritos</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Jornada {proximaJornada.numero}</td>
                    <td>
                      {new Date(proximaJornada.fecha).toLocaleDateString('es-ES', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                      })}
                    </td>
                    <td>{proximaJornada.hora ? proximaJornada.hora.substring(0, 5) : '-'}</td>
                    <td>{proximaJornada.sede_nombre || 'Sin sede'}</td>
                    <td>
                      {proximaJornada.sede_poblacion || 'Sin ubicación'}
                      {proximaJornada.sede_direccion && `, ${proximaJornada.sede_direccion}`}
                    </td>
                    <td>{proximaJornada.total_inscritos || 0}</td>
                    <td>
                      <span className="status-badge scheduled">Programada</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                No hay jornadas programadas
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="dashboard-row">
        <div className="dashboard-card recent-users">
          <div className="card-header">
            <h2>Usuarios Recientes</h2>
            <Link to="/admin/users" className="btn-link">
              Ver Todos
            </Link>
          </div>
          <div className="card-content">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Categoría</th>
                  <th>Fecha Registro</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {recentUsers.map((user) => (
                  <tr key={user._id || user.id}>
                    <td className="user-cell">
                      <img src={user.avatar || '/img/default-avatar.jpg'} alt={user.name} />
                      <div>
                        <p className="user-name">{user.name}</p>
                        <p className="user-email">{user.email}</p>
                      </div>
                    </td>
                    <td>
                      {user.category ||
                        (user.role === 'user'
                          ? 'U10 Boys'
                          : user.role === 'parent'
                            ? 'U8 Girls'
                            : 'U12 Mixed')}
                    </td>
                    <td>{user.registeredAt.toLocaleDateString('es-ES')}</td>
                    <td>
                      <span className={`status-badge ${user.status}`}>
                        {user.status === 'active' && 'Activo'}
                        {user.status === 'pending' && 'Pendiente'}
                        {user.status === 'inactive' && 'Inactivo'}
                      </span>
                    </td>
                    <td className="action-buttons">
                      <button
                        className="action-button"
                        title="Editar usuario"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditUser(user);
                        }}
                      >
                        <span className="material-icons">edit</span>
                      </button>
                      <button
                        className="action-button"
                        title="Ver detalles del usuario"
                        onClick={(e) => {
                          e.preventDefault();
                          handleViewUser(user);
                        }}
                      >
                        <span className="material-icons">visibility</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal para ver detalles del usuario */}
      {showUserViewModal && currentUser && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h2>Detalles del Usuario</h2>
              <button
                className="modal-close-btn"
                onClick={() => {
                  setShowUserViewModal(false);
                  setCurrentUser(null);
                }}
              >
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="user-details">
                <div className="user-details-header">
                  <img
                    src={currentUser.avatar || '/img/default-avatar.jpg'}
                    alt={currentUser.name}
                    className="user-avatar"
                  />
                  <div className="user-details-info">
                    <h3>{currentUser.name}</h3>
                    <p className="user-email">{currentUser.email}</p>
                    <p className="user-id">ID: {currentUser._id || currentUser.id}</p>
                  </div>
                </div>

                <div className="user-details-content">
                  <div className="details-section">
                    <h4>Información Personal</h4>
                    <div className="details-grid">
                      <div className="detail-item">
                        <span className="detail-label">Rol:</span>
                        <span className="detail-value">
                          {currentUser.role === 'admin'
                            ? 'Administrador'
                            : currentUser.role === 'coach'
                              ? 'Entrenador'
                              : currentUser.role === 'parent'
                                ? 'Padre/Madre'
                                : 'Usuario'}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Estado:</span>
                        <span className={`status-badge ${currentUser.status}`}>
                          {currentUser.status === 'active' && 'Activo'}
                          {currentUser.status === 'pending' && 'Pendiente'}
                          {currentUser.status === 'inactive' && 'Inactivo'}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Teléfono:</span>
                        <span className="detail-value">
                          {currentUser.phone || 'No especificado'}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">Fecha de registro:</span>
                        <span className="detail-value">
                          {currentUser.registeredAt
                            ? new Date(currentUser.registeredAt).toLocaleDateString('es-ES')
                            : 'Desconocida'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowUserViewModal(false);
                  setCurrentUser(null);
                }}
              >
                Cerrar
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowUserViewModal(false);
                  handleEditUser(currentUser);
                }}
              >
                Editar Usuario
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para editar usuario */}
      <UserEditModal
        isOpen={showUserEditModal}
        onClose={() => {
          setShowUserEditModal(false);
          setCurrentUser(null);
        }}
        user={currentUser}
        onUserUpdated={handleUserUpdated}
      />
    </AdminLayout>
  );
};

export default Dashboard;
